<template>
    <Tag
        data-testid="document-type"
        v-bind="documentTypeMeta"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { type PropType } from 'vue';
import { DOCUMENT_CONTENT_TYPE } from '@/utils/documentUtils';
import { DocumentType } from './TagDocumentType';

export default defineComponent({
    name: 'TagDocumentType',
    props: {
        /**
         * The type of the document.
         * Example: summary, lecture, exam, assignment, and other.
         */
        type: {
            type: [String, Number] as PropType<DocumentType | number>,
            required: true,
        },
    },
    computed: {
        documentTypeMeta() {
            switch (this.type) {
                case DocumentType.Summary:
                case DOCUMENT_CONTENT_TYPE.SUMMARY:
                    return { text: this.$t('documentTypes.80'), colorClass: 'bg-blue-100 text-blue-800' };
                case DocumentType.Lecture:
                case DOCUMENT_CONTENT_TYPE.LECTURE:
                    return { text: this.$t('documentTypes.20'), colorClass: 'bg-green-100 text-green-500' };
                case DocumentType.Exam:
                case DOCUMENT_CONTENT_TYPE.EXAM:
                    return { text: this.$t('documentTypes.60'), colorClass: 'bg-red-100 text-red-600' };
                case DocumentType.Assignment:
                case DOCUMENT_CONTENT_TYPE.ASSIGNMENT:
                    return { text: this.$t('documentTypes.30'), colorClass: 'bg-yellow-50 text-yellow-500' };
                case DocumentType.Other:
                case DOCUMENT_CONTENT_TYPE.OTHER:
                default:
                    return { text: this.$t('documentTypes.10'), colorClass: 'bg-purple-100 text-purple-950' };
            }
        },
    },
});
</script>
